// New — Figma's ESG page header also has a date-range combobox (node 18202:413, "Last 30
// days" + calendar icon) next to Export, with a dropdown of 5 fixed options (nodes
// 18249:157538 family: Last 7/14/30/60/90 days). LC2 has no equivalent at all.
//
// NOT WIRED TO REAL DATA — flagged as a backend gap, not silently faked. I checked the real
// backend (stake-core-api's esg_dashboard_routes.py, both get_property_esg_dashboard and
// get_portfolio_esg_dashboard): neither route reads any query/body param at all — there is
// no date-range, period, or window parameter for this frontend to send. So this control
// only updates its own local label for now; selecting a range does not (and structurally
// cannot yet) change the Financial Unlocks / Staker Insights / ESG Metrics numbers shown
// below it. Once the backend adds a real parameter for this, wire `selectedRange.days` into
// EsgSection.js's fetchAccountsEsg/fetchCommunityEsg calls the same way AlertsSection.js
// wires its own "Last 7/30/60 days" shortcut into its date-scoped fetch.
import React, {useRef, useState} from 'react';
import {Box, ButtonBase, ClickAwayListener, Popper, Typography} from '@mui/material';

import {tokens} from '../../../themes/ThemeCustomization';
import calendarIcon from '../../../assets/esg/calendar-icon.svg';
import chevronIcon from '../../../assets/esg/date-range-chevron-icon.svg';

const RANGE_OPTIONS = [
    {label: 'Last 7 days', days: 7},
    {label: 'Last 14 days', days: 14},
    {label: 'Last 30 days', days: 30},
    {label: 'Last 60 days', days: 60},
    {label: 'Last 90 days', days: 90}
];

const DateRangeSelector = () => {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(RANGE_OPTIONS[2]); // "Last 30 days" — Figma's default

    return (
        <Box ref={anchorRef} sx={{display: 'flex'}}>
            <ButtonBase
                onClick={() => setOpen(true)}
                sx={{
                    width: '36px',
                    height: '36px',
                    justifyContent: 'center',
                    border: `1px solid ${tokens.color.neutral200}`,
                    borderTopLeftRadius: '6px',
                    borderBottomLeftRadius: '6px',
                    backgroundColor: tokens.color.white
                }}
            >
                <Box component="img" src={calendarIcon} alt="" sx={{width: 16, height: 16}} />
            </ButtonBase>
            <ButtonBase
                onClick={() => setOpen(true)}
                sx={{
                    height: '36px',
                    px: 1,
                    columnGap: 1,
                    border: `1px solid ${tokens.color.neutral200}`,
                    borderLeft: 'none',
                    borderTopRightRadius: '6px',
                    borderBottomRightRadius: '6px',
                    backgroundColor: tokens.color.white
                }}
            >
                <Typography variant="body2">{selected.label}</Typography>
                <Box component="img" src={chevronIcon} alt="" sx={{width: 16, height: 16}} />
            </ButtonBase>

            <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start" sx={{zIndex: 1300}}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                    <Box
                        sx={{
                            mt: 0.5,
                            width: '190px',
                            p: 1,
                            backgroundColor: tokens.color.white,
                            border: `1px solid ${tokens.color.neutral200}`,
                            borderRadius: '12px',
                            boxShadow: tokens.shadow.toast
                        }}
                    >
                        {RANGE_OPTIONS.map((option) => (
                            <ButtonBase
                                key={option.days}
                                onClick={() => {
                                    setSelected(option);
                                    setOpen(false);
                                }}
                                sx={{
                                    width: '100%',
                                    height: '36px',
                                    borderRadius: '6px',
                                    justifyContent: 'flex-start',
                                    px: 1,
                                    backgroundColor: option.days === selected.days ? tokens.color.neutral100 : 'transparent',
                                    '&:hover': {backgroundColor: tokens.color.neutral100}
                                }}
                            >
                                <Typography variant="body2">{option.label}</Typography>
                            </ButtonBase>
                        ))}
                    </Box>
                </ClickAwayListener>
            </Popper>
        </Box>
    );
};

export default DateRangeSelector;
